import { Component, type ReactElement } from 'react';
import type { FetchServicedeskPortalAction } from '../state/actions.tsx';
import type { ServicedeskPortalId } from '../state/types.tsx';

export type Props = {
	projectId: number;
	portalId?: ServicedeskPortalId;
	children: (props: { servicedeskPortalId?: ServicedeskPortalId }) => ReactElement;
	onFetchServicedeskPortal: (projectId: number) => FetchServicedeskPortalAction;
};

// eslint-disable-next-line jira/react/no-class-components
class ServicedeskPortalProvider extends Component<Props> {
	componentDidMount() {
		const { projectId, onFetchServicedeskPortal } = this.props;
		onFetchServicedeskPortal(projectId);
	}

	componentDidUpdate(prevProps: Props) {
		const { projectId, onFetchServicedeskPortal } = this.props;
		if (prevProps.projectId !== projectId) {
			onFetchServicedeskPortal(projectId);
		}
	}

	render() {
		const { portalId, children } = this.props;

		return children({ servicedeskPortalId: portalId });
	}
}

export default ServicedeskPortalProvider;
